import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { NavLink, Route, Routes } from "react-router-dom";
import Shell from "../components/Shell";
import AdminDashboard from "./admin/Dashboard";
import AdminStudents from "./admin/Students";
import AdminExams from "./admin/Exams";
import AdminMarks from "./admin/Marks";
import AdminReports from "./admin/Reports";
import AdminLogins from "./admin/Logins";
import AdminImport from "./admin/Import";
import AdminHelp from "./admin/Help";
const NAV = [
    { to: "", label: "Dashboard" },
    { to: "students", label: "Students" },
    { to: "exams", label: "Exams" },
    { to: "marks", label: "Marks" },
    { to: "reports", label: "Reports" },
    { to: "logins", label: "Logins" },
    { to: "import", label: "Import" },
    { to: "help", label: "Help" },
];
export default function Admin() {
    return (_jsx(Shell, { children: _jsxs("div", { className: "grid gap-6 lg:grid-cols-[180px_1fr]", children: [_jsx("aside", { className: "flex lg:flex-col gap-1 overflow-x-auto lg:overflow-visible", children: NAV.map((n) => (_jsx(NavLink, { to: `/admin/${n.to}`, end: n.to === "", className: ({ isActive }) => `px-3 py-2 rounded text-sm whitespace-nowrap ${isActive
                            ? "bg-paper-2 border border-line text-ink font-semibold"
                            : "text-slate2 hover:text-ink hover:bg-paper-2"}`, children: n.label }, n.to))) }), _jsx("div", { className: "min-w-0", children: _jsxs(Routes, { children: [_jsx(Route, { index: true, element: _jsx(AdminDashboard, {}) }), _jsx(Route, { path: "students/*", element: _jsx(AdminStudents, {}) }), _jsx(Route, { path: "exams/*", element: _jsx(AdminExams, {}) }), _jsx(Route, { path: "classes/:classId/exams", element: _jsx(AdminExams, {}) }), _jsx(Route, { path: "marks", element: _jsx(AdminMarks, {}) }), _jsx(Route, { path: "reports/*", element: _jsx(AdminReports, {}) }), _jsx(Route, { path: "logins/*", element: _jsx(AdminLogins, {}) }), _jsx(Route, { path: "import", element: _jsx(AdminImport, {}) }), _jsx(Route, { path: "help", element: _jsx(AdminHelp, {}) })] }) })] }) }));
}
